<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'inventory-outsourcingStockOut',
  components: {
    PageTable,
  },
}
</script>
